// extracted by mini-css-extract-plugin
export default {"removeButton":"RemoveButton_removeButton__2fUiw","confirmWrapper":"RemoveButton_confirmWrapper__yCv6a"};